<template>
    <div class="d-flex align-items-center px-3 mt-4 gap-2">
        <FlightOriginDropdown />
        <FlightDatePicker />
        <FlightParticipants />
    </div>
</template>

<script setup lang="ts">
// Vuex
import {useStore} from "vuex"

// Components
import FlightOriginDropdown from './flightOriginDropDown.vue';
import FlightDatePicker from "./flightDatePicker.vue"
import FlightParticipants from './flightParticipants.vue';

const store = useStore()

</script>

<style scoped></style>